<template>
    <div class="bg-gray-850 rounded-full flex items-center space-x-4 relative">
        <div
            v-if="isStarterUser"
            @click="showPromotionModal = true"
            :id="$t('upgrade-header-button')"
            class="header-cta-style flex w-full rounded-full py-2 px-4 text-body-sm font-medium text-gray-100 cursor-pointer max-h-9"
        >
            <div class="flex space-x-2 items-center justify-center">
                <PricingPlanBadge class="!w-5 !h-4" plan-name="pro" />
                <p class="text-body-sm font-medium">{{ $t("global_upgrade") }}</p>
            </div>
        </div>
        <AppPopover id="user-credit-popover" parent-class="right-0">
            <template #button>
                <div
                    class="flex items-center px-2 py-2 w-fit bg-gray-850 rounded-full justify-center text-gray-100 text-body-sm font-bold cursor-pointer"
                    @click="handleClick"
                >
                    {{ userData.roles.includes("tester-user") ? userData.test_balance : userData.balance }}

                    <AppCoin
                        :color="
                            userData.roles.includes('restricted-user') ||
                            userData.roles.includes('restricted-subaccount') ||
                            userData.roles.includes('lock-subaccount')
                                ? 'gray'
                                : 'gold'
                        "
                        size="md"
                        class="ml-2"
                    />
                </div>
            </template>

            <template #content="{ close }">
                <div class="bg-black overflow-hidden relative rounded-2xl p-6 w-[234px]">
                    <div ref="hiddenElementID" class="hidden" @click="close()"></div>
                    <div
                        v-if="!userData.free_plan"
                        class="rounded-full z-0 absolute -top-14 right-6 w-[185px] h-[119px] blur-[80px]"
                        :class="
                            userData.roles.includes('restricted-user') ||
                            (Object.keys(userData).keys.length > 0 &&
                                userData?.roles?.includes('restricted-subaccount'))
                                ? 'bg-[#B7B7B7]'
                                : 'bg-[#6E24F0]'
                        "
                    ></div>
                    <component
                        @close:popover="close()"
                        @click:credit-pack="$emit('click:credit-pack')"
                        :is="userDataPopoverComponent"
                    />
                </div>
            </template>
        </AppPopover>
    </div>
</template>

<script setup lang="ts">
import { useUserStore } from "~/store/global/user.store";
const { userData, isStarterUser } = storeToRefs(useUserStore());

const { showPromotionModal } = useDownloadPhoto();
const showMobileMenu = useMobileMenuOpen();
const hiddenElementID = ref<null | HTMLDivElement>(null);

watch(showMobileMenu, () => {
    hiddenElementID.value?.click();
});

const { isDesktop } = useDevice();

const handleClick = (event: Event) => {
    if (isDesktop) event.preventDefault();
};

const userDataPopoverComponent = computed(() => {
    if (userData.value.roles.includes("tester-user"))
        return defineAsyncComponent(() => import("./AppCreditPopoverTesterRole.vue"));
    if (userData.value.roles.includes("restricted-subaccount"))
        return defineAsyncComponent(() => import("./AppRestrictedSubaccountPopover.vue"));
    if (userData.value.roles.includes("restricted-user"))
        return defineAsyncComponent(() => import("./AppRestrictedPopover.vue"));
    if (userData.value.domain === "subaccount")
        return defineAsyncComponent(() => import("./AppCreditSubaccountPopover.vue"));
    else return defineAsyncComponent(() => import("./AppNormalCreditPopover.vue"));
});
</script>

<style scoped>
.header-cta-style {
    box-shadow: 2px 0px 8.4px 0px rgba(244, 149, 124, 0.44), 0px 9px 23.7px -32px rgba(77, 77, 189, 0.6);
    background: linear-gradient(90deg, #4d4dbd 8.11%, #da5b3c 104.11%) padding-box,
        linear-gradient(to right, #4d4dbd, #da5b3c) border-box;
    border: 1px solid rgba(255, 255, 255, 0.4);
}
</style>
